import { z } from 'zod';

import i18n from '@/lib/i18n';
import { mainstreamCountrySchema } from '@/services/api/mainstream';
import { createTaxIdentificationNumberRefinement } from './refinements/tax-identification-number';

export const TAX_RESIDENCES_MAX = 5;

// Selects the `_individual` copy when the residences are someone else's, e.g. an institution's director
export type TaxResidencySubject = 'individual';

export type TaxResidence = {
  country: string;
  taxId: string;
};

type TaxResidenceApi = {
  country: string;
  taxId?: string;
};

export const TAX_RESIDENCE_DEFAULTS = {
  country: '',
  taxId: '',
} satisfies TaxResidence;

export const createTaxResidencesSchema = (subject?: TaxResidencySubject) =>
  z
    .array(
      z
        .object({
          country: mainstreamCountrySchema(i18n.t('taxResidency.errors.country', { context: subject })),
          taxId: z.string(),
        })
        .superRefine(createTaxIdentificationNumberRefinement(subject)),
    )
    .min(1)
    .max(TAX_RESIDENCES_MAX)
    .superRefine((taxResidences, context) => {
      taxResidences.forEach(({ country }, index) => {
        if (taxResidences.findIndex((taxResidence) => taxResidence.country === country) !== index) {
          context.addIssue({ code: 'custom', message: i18n.t('taxResidency.errors.countryDuplicate'), path: [index, 'country'] });
        }
      });
    });

export const taxResidenceToTaxResidenceApi = ({ country, taxId }: TaxResidence): TaxResidenceApi => ({ country, ...(taxId && { taxId }) });

export const taxResidenceApiToTaxResidence = ({ country, taxId }: TaxResidenceApi): TaxResidence => ({ country, taxId: taxId ?? '' });
